import { createAction } from '@reduxjs/toolkit';

const prefix = 'app/modal/';

type ChangeModalVisibilityPayload = {
  visible: boolean;
  modalName: string;
  shouldKeepOtherModalVisibleOnShow?: boolean;
};

// Docs: https://redux-toolkit.js.org/api/createAction
export const changeModalVisibility = createAction<ChangeModalVisibilityPayload>(
  `${prefix}CHANGE_VISIBILITY`,
);

export const hideModal = (modalName: string) =>
  changeModalVisibility({ modalName, visible: false });

export const showModal = (modalName: string) =>
  changeModalVisibility({ modalName, visible: true });

export const showModalInsideModal = (modalName: string) =>
  changeModalVisibility({
    modalName,
    visible: true,
    shouldKeepOtherModalVisibleOnShow: true,
  });

export const hideAllModals = createAction<any>(`${prefix}HIDE_ALL`);
